import { render, staticRenderFns } from "./SupervisorForm.vue?vue&type=template&id=b77ad32a"
import script from "./SupervisorForm.vue?vue&type=script&lang=js"
export * from "./SupervisorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports